module.exports = __webpack_public_path__ + "static/img/bg_image.7cb11ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/auth/bg_image.png
// module id = /Qz+
// module chunks = 0